// Icon buttons for the bag's line and bill tools. Each icon is inline SVG
// drawn in currentColor, so it follows the theme. The button names itself
// to screen readers (aria-label) and shows the same name as a tip on hover
// or keyboard focus. A dot marks a tool that already holds something (a
// note, a rep, a discount).
import React from "react";

const PATHS = {
  rep: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" />
    </>
  ),
  discount: (
    <>
      <path d="M19 5 5 19" />
      <circle cx="7" cy="7" r="2.5" />
      <circle cx="17" cy="17" r="2.5" />
    </>
  ),
  price: (
    <>
      <path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9Z" />
      <circle cx="8" cy="8" r="1.5" />
    </>
  ),
  note: (
    <>
      <path d="M5 3h10l4 4v14H5Z" />
      <path d="M9 11h6M9 15h6M9 7h3" />
    </>
  ),
  alteration: (
    <>
      <circle cx="6" cy="6" r="3" />
      <circle cx="6" cy="18" r="3" />
      <path d="M8.1 8.1 20 20M8.1 15.9 20 4" />
    </>
  ),
  bag: (
    <>
      <path d="M5 8h14l-1 13H6Z" />
      <path d="M9 10V6a3 3 0 0 1 6 0v4" />
    </>
  ),
  park: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M10 8v8M14 8v8" />
    </>
  ),
  clear: (
    <>
      <path d="M4 7h16M10 11v6M14 11v6" />
      <path d="M6 7l1 14h10l1-14M9 7V4h6v3" />
    </>
  ),
  cancel: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m9 9 6 6M15 9l-6 6" />
    </>
  ),
};

export function ToolIcon({ name }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      {PATHS[name]}
    </svg>
  );
}

export default function ToolButton({ icon, label, hint, on = false, dot = false, danger = false, expanded, disabled, onClick }) {
  const tip = hint ? `${label} (${hint})` : label;
  return (
    <button
      type="button"
      className={`fp-tb${on ? " is-on" : ""}${dot ? " has-dot" : ""}${danger ? " is-danger" : ""}`}
      aria-label={label}
      aria-expanded={expanded}
      data-tip={tip}
      disabled={disabled}
      onClick={onClick}
    >
      <ToolIcon name={icon} />
    </button>
  );
}
